/** @format */

import React from "react"
import { PopinConfirmationProps } from "./BuyMoreConfirmationPopin.types"
import {
	IconBuyMore,
	Body,
	IconNoPost,
	StyledPopin,
} from "./BuyMoreConfirmationPopin.styled"

export const BuyMoreConfirmationPopin = (props: PopinConfirmationProps) => {

	return (
		<StyledPopin
			open={props.open}
			size="small"
			onClose={() => props.onClosePopin(false)}
		>
			{props.shouldSendEmail && (
				<Body data-testid="gsl.uilib.buyMoreResponse.confirm.Popin">
					<IconNoPost data-testid="icon-NoPost"></IconNoPost>
					<p className="title">Merci pour votre demande</p>
					<p className="text-wrapper">
						Votre demande a bien été prise en compte. Nous vous contacterons
						rapidement !
					</p>
				</Body>
			)}
			{!props.shouldSendEmail && (
				<Body data-testid="gsl.uilib.buyMoreResponse.decline.Popin">
					<IconBuyMore data-testid="icon-BuyMore"></IconBuyMore>
					<p className="title">Nous restons à l’écoute de vos besoins</p>
					<p className="text-wrapper">
						Nous sommes là pour vous aider à élargir votre réseau et booster
						votre visibilité.
					</p>
				</Body>
			)}
		</StyledPopin>
	)
}
